import md5 from "md5";
import getConfig from "next/config";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const ProductReviewsImages = ({ reviewsWithImages, onImageSelect }) => (
  <>
    {reviewsWithImages.map((review) =>
      review.images.map((image, index) => (
        <img
          className="object-cover aspect-square cursor-pointer h-[120px] rounded-[4px]"
          key={image}
          src={`${settings.cdn}/resize/reviews-files/${review._id}/${md5(
            "120x0"
          )}/${image}`}
          alt={review._id}
          onClick={() =>
            onImageSelect({ reviewId: review._id, imageIndex: index })
          }
        />
      ))
    )}
  </>
);

export default ProductReviewsImages;
